import React from 'react';
import { Field } from 'redux-form';
import { FormControlLabel, Radio, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import InlineFormRadioGroup from '../../../Auth/Registration/components/InlineFormRadioGroup';
import { required } from '../../../../utils/validators';
import { PAYMENT_METHODS_STATUSES } from '../../../../constants';
import { StyledRadio } from './StyledRadio';

const StyledInlineFormRadioGroup = styled(InlineFormRadioGroup)`
  label:last-child {
    margin-left: 5px;
  }
`;

const FinalizeAchFlooringApprovalPicker = () => (
  <Field name="payment_status" component={StyledInlineFormRadioGroup} row validate={required}>
    <FormControlLabel
      style={{ marginLeft: '-7px', color: 'green' }}
      control={<StyledRadio />}
      value={PAYMENT_METHODS_STATUSES.APPROVED}
      label="Approve"
    />
    <FormControlLabel control={<StyledRadio />} value={PAYMENT_METHODS_STATUSES.DECLINED} label="Decline" />
  </Field>
);

export default FinalizeAchFlooringApprovalPicker;
